// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__VOV3Y","col":"styles_col__1JV1V","fulfillmentStatus":"styles_fulfillmentStatus__2FghJ","emailCol":"styles_emailCol__2tTaa"};